import React, { useState, useEffect, useRef } from "react";
import Layout from "../../../components/Layout";
import { get, post } from "../../../services/ApiService";
import "../../custom-style.css";
import "./style.css";
import Loader from "../../../components/Loader";
import toast, { Toaster } from "react-hot-toast";
import { Link, useParams, useLocation } from "react-router-dom";
import Breadcrumbs from "../../../components/Breadcrumbs";
import OrderProgressStepper from "./components/OrderProgressStepper";
import OrderDetailCard from "./components/OrderDetailCard";
import ProductAssessments from "./components/ProductAssessments";
import GslReviewActions from "./components/GslReviewActions";
import PcatdReviewActions from "./components/PcatdReviewActions";
import OrderNotes from "./components/OrderNotes";
import {
  DateFormater,
  DateTimeFormater,
  truncateText,
  getStatus,
  isDispatchScheduledForLater,
} from "../../../services/Helper";
import { Button, Modal } from "antd";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import { useSelector } from "react-redux";
import { selectUserId } from "../../../redux/selector";
import ChatHistory from "./ChatHistory";
import usePermissionCheck from "../../../hooks/usePermissionCheck";
import OrdersHistory from "./OrdersHistory";
import { useNavigate } from "react-router-dom";

const Assessment = () => {
  const { id } = useParams();
  const userId = useSelector(selectUserId);
  const location = useLocation();
  const navigate = useNavigate(); 
  const queryParams = new URLSearchParams(location.search);
  const canAutomation = usePermissionCheck(["order.automation"]);
  const canEdit = usePermissionCheck(["order.edit"]);
  const canStatusEdit = usePermissionCheck(["order.can_status_change"]);
  const canApprove = usePermissionCheck(["order.approve"]);
  const canDecline = usePermissionCheck(["order.decline"]);
  const canMarkPending = usePermissionCheck(["order.mark_pending"]);
  const canCancel = usePermissionCheck(["order.cancel"]);
  const canRefund = usePermissionCheck(["order.refund"]);
  const canViewMsg = usePermissionCheck(["order.view_message"]);
  const canSendMsg = usePermissionCheck(["order.send_message"]);
  const canSendToCourier = usePermissionCheck(["order.send_to_rm"]);

  const [isCourierSending, setIsCourierSending] = useState(false);
  const [openCourierModal, setOpenCourierModal] = useState(false);
  const [openExternalResultModal, setOpenExternalResultModal] = useState(false);
  const [externalResultData, setExternalResultData] = useState(null);
  const [isCourierDispatching, setIsCourierDispatching] = useState(false);

  const [isLoading, setIsLoading] = useState(true);
  const [isChatLoading, setIsChatLoading] = useState(true);
  const [isSending, setIsSending] = useState(false);
  const [isNotFound, setNotFound] = useState(false);
  const [isNoMessage, setNoMessage] = useState(false);
  const [NoMessageText, setNoMessageText] = useState("");
  const [assessment, setAssessment] = useState("");
  const [mailLogs, setMailLogs] = useState([]);
  const [productIds, setProductIds] = useState([]);
  const [messages, setMessages] = useState([]);
  const [message, setMessage] = useState("");
  const [attachments, setAttachments] = useState([]);
  const textareaRef = useRef(null);
  const [order, setOrder] = useState("");
  const [openCases, setOpenCases] = useState([]);
  const [openEscalations, setOpenEscalations] = useState([]);
  const isEligibleForCourier =
    (order?.status === "SEND_TO_RM" || order?.status === "PRIME_READY") &&
    !isDispatchScheduledForLater(order);
  const [customer, setCustomer] = useState(null);
  const [idCheckSummary, setIdCheckSummary] = useState(null);
  const [groupedOrders, setGroupedOrders] = useState({});
  const [notes, setNotes] = useState([]);
  const [reminder, setReminder] = useState(order?.reminder || 0);
  const [reminderLoading, setReminderLoading] = useState(false);
  const [faqs, setFaqs] = useState([]);
  const [questions, setQuestions] = useState([]);
  const [isCancelRefund, setIsCancelRefund] = useState(false);
  const [ticket, setTicket] = useState(null);
  const [hasUnreadMessage, setHasUnreadMessage] = useState(false);
  const [hasMoreMessages, setHasMoreMessages] = useState(false);
  const [amazonMessagingInfo, setAmazonMessagingInfo] = useState(null);


  useEffect(() => {
    fetchData();
    getMessages();
  }, [id]);

  useEffect(() => {
    const fetchAmazonMessagingInfo = async () => {
      if (!order?._id || order?.platform !== "Amazon") {
        setAmazonMessagingInfo(null);
        return;
      }

      try {
        const res = await get(`api/messages/order/${order._id}/amazon-actions`);
        if (res.success) {
          setAmazonMessagingInfo(res);
        } else {
          setAmazonMessagingInfo({
            canSendMessage: false,
            disabledReason:
              res.error || "Amazon messaging is not available for this order.",
          });
        }
      } catch (error) {
        setAmazonMessagingInfo({
          canSendMessage: false,
          disabledReason:
            "Amazon messaging is not available for this order.",
        });
      }
    };

    fetchAmazonMessagingInfo();
  }, [order?._id, order?.platform]);

  useEffect(() => {
    if (textareaRef.current) {
      textareaRef.current.style.height = "auto";
      textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`;
    }
  }, [message]);

  

  const fetchData = async () => {
    try {
      setIsLoading(true);
      const res = await get(
        `api/orders/p-med/assessment/${id}`
      );
      setIsLoading(false);
      if (res.success) {
        setOrder(res.order);
        setOpenCases(res.openCases || []);
        setOpenEscalations(res.openEscalations || []);
        setCustomer(res.customer);
        setIdCheckSummary(res.idCheckSummary || null);
        setReminder(res.order?.reminder);
        setAssessment(res.assessment);
        setMailLogs(res.mailLogs);
        setNotes(res.notes);
        setFaqs(res.faqs);
        setQuestions(res.questions || []);
        if (res.assessment && res.assessment.products) {
          const ids = res.assessment.products.map(
            (product) => product.productId
          );
          setProductIds(ids);
        }

        const orders = res.orders;
        if (orders.length > 0) {
          const grouped = groupOrdersByMonth(orders);
          setGroupedOrders(grouped);
        }
      } else {
        setOrder("");
        setAssessment("");
        setNotFound(true);
      }
    } catch (error) {
      setIsLoading(false);
      setOrder("");
      setAssessment("");
      setNotFound(true);
    }
  };

  const getMessages = async () => {
    try {
      setIsChatLoading(true);
      setNoMessage(false);
      const res = await get(`api/messages/${id}?limit=30`);
      setIsChatLoading(false);
      if (res.success) {
        setMessages(res.data);
        setTicket(res.ticket);
        setHasUnreadMessage(res.hasUnreadMessage);
        setHasMoreMessages(res.hasMore);
      } else {
        setNoMessageText(res.error);
        setNoMessage(true);
      }
    } catch (error) {
      setIsChatLoading(false);
      setNoMessage(true);
      setNoMessageText(error);
      console.log(error);
    }
  };

  const loadOlderMessages = async () => {
    if (!hasMoreMessages || messages.length === 0) return;
    const oldest = messages[0];
    try {
      const res = await get(`api/messages/${id}?limit=30&before=${oldest.creationDate}`);
      if (res.success) {
        setMessages((prev) => [...res.data, ...prev]);
        setHasMoreMessages(res.hasMore);
      }
    } catch (error) {
      console.log("Failed to load older messages:", error);
    }
  };


  const handleSendMessage = async () => {
    if (!message && message === "") {
      toast.error("Enter your message first");
      return;
    }
    const formData = new FormData();
    formData.append("message", message);
    formData.append("orderId", id);
      attachments.forEach((file, index) => {
      formData.append("files", file);
    });
    setIsSending(true);
    let res;
    try {
      res = await post(`api/messages/send`, formData, true);
    } catch (error) {
      toast.error(error?.response?.data?.error || "Failed to send message");
      return;
    } finally {
      setIsSending(false);
    }
    if (res.success) {
      toast.success("Message sent");
      const shouldShowOrderLabel = messages.some((existingMessage) => existingMessage.orderIdLabel);
      const newMessage = {
        body: message,
        creationDate: new Date().toISOString(),
        messageID: "",
        order: id,
        orderIdLabel: shouldShowOrderLabel ? order?.orderId || null : null,
        sender: "pillpharm",
        subject: "",
      };
      setMessages((prevMessages) => [...prevMessages, newMessage]);
      setAttachments([]);
      setMessage("");
    }
  };

  const groupOrdersByMonth = (orders) => {
    const groupedOrders = {};
    orders.forEach((order) => {
      const date = new Date(order.createdAt);
      const month = date.toLocaleString("default", { month: "long" });
      const year = date.getFullYear();
      const monthYear = `${month} ${year}`;

      if (!groupedOrders[monthYear]) {
        groupedOrders[monthYear] = [];
      }
      groupedOrders[monthYear].push(order);
    });

    return groupedOrders;
  };

  const cancel = (e) => {};

  const handleReminderChange = async (orderId, reminder) => {
    try {
      const Body = {
        id: orderId,
        reminder,
      };
      setReminderLoading(true);
      const res = await post(`api/orders/reminder/update`, Body);

      setReminderLoading(false);
      if (res.success) {
        setReminder(res.order.reminder);
        toast.success("Reminder updated successfully.");
      } else {
        toast.error("Failed to update reminder status.");
      }
    } catch (error) {
      toast.error("Error updating reminder status.");
    }
  };

  const orderCancelRefund = async (type) => {
    try {
      const Body = {
        orderId: order._id,
        type,
      };
      setIsCancelRefund(true);
      const res = await post("api/orders/status/cancel", Body);
      setIsCancelRefund(false);
      if (res.success) {
        setOrder(res.order);
        toast.success(res.message);
      } else {
        toast.error(res.error);
      }
    } catch (error) {
      setIsCancelRefund(false);
      console.log(error);
      toast.error("An error occurred. Please try again.");
    }
  };

  const handleCloseTicket = (ticket) => {
    setTicket(ticket);
  }

  const orderStatusChange = async (status) => {
    try {
      const Body = {
        orderId: order._id,
        status,
      };
      const res = await post("api/orders/status/change", Body);
      if (res.success) {
        setOrder(res.order);
        toast.success(res.message);
      } else {
        toast.error(res.error);
      }
    } catch (error) {
      console.log(error);
      toast.error("An error occurred. Please try again.");
    }
  };

  const handleSendToCourier = async () => {
    try {
      const res = await get("api/orders/courier/lock");
      if (res.success && res.isLocked) {
        toast.error("A dispatch is already in progress, please wait.");
        return;
      }
      setOpenCourierModal(true);
    } catch (error) {
      toast.error("Could not check dispatch status. Please try again.");
    }
  };

  const handleCourierConfirm = async () => {
    setIsCourierSending(true);
    setOpenCourierModal(false);
    setIsCourierDispatching(true);

    try {
      const res = await get(`api/orders/prepare/courier?orderId=${order.orderId}`);
      console.log(res);
      if (res.isExternal) {
        const externalData = res.external;
        setExternalResultData(externalData);
        setOpenExternalResultModal(true);

        return;
      }

      navigate(`/orders/courier-jobs`);

      if (!res?.success) {
        throw new Error(res?.message || res?.error || "Courier dispatch failed.");
      }

      toast.success("Order successfully sent to courier. Labels on courier Jobs page");
      await fetchData();
    } catch (error) {
      const data = error?.response?.data;
      if (data?.isExternal) {
        const externalData = data.external || data;
        setExternalResultData(externalData);
        setOpenExternalResultModal(true);
        if (!data?.success) {
          toast.error(
            data?.message || data?.error ||
              "External dispatch failed. Please check the external system for details."
          );
        }
      } else {
        toast.error(
          data?.message || data?.error || error?.message ||
            "Error sending order to courier."
        );
      }
    } finally {
      setIsCourierSending(false);
      setIsCourierDispatching(false);
    }
  };

  const isPcatdAwaitingReview =
    order?.type === "P-CAT-D" &&
    (order?.status === "PENDING" || order?.status === "PENDING_REVIEW");
  const hasUnreviewedAssessment =
    Boolean(assessment?.products?.length) && !assessment?.isReview;
  const isGslRepeatReview =
    order?.status === "PENDING_REVIEW" && !hasUnreviewedAssessment;

  return (
    <>
      <Layout>
        <Toaster position="top-center" reverseOrder={false} />
        <div>

          <div className="row mb-9 align-items-center justify-content-between">
            <div className="col-sm-6 mb-8 mb-sm-0">
              <h2 className="fs-4 mb-0">Order Detail</h2>
              <Breadcrumbs />
            </div>
            {canSendToCourier && isEligibleForCourier && (
              <div className="col-sm-6 d-flex justify-content-sm-end">
                <button
                  className="btn btn-sm"
                  onClick={handleSendToCourier}
                  disabled={isCourierDispatching}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "6px",
                    fontWeight: 600,
                    backgroundColor: "#4e7661",
                    borderColor: "#4e7661",
                    color: "#fff",
                    cursor: isCourierDispatching ? "not-allowed" : "pointer",
                    opacity: isCourierDispatching ? 0.7 : 1,
                  }}
                >
                  {isCourierDispatching ? (
                    <>
                      <i className="fa fa-spinner fa-spin" />
                      Dispatching...
                    </>
                  ) : (
                    <>
                      SEND THIS TO COURIER
                      <i className="fa fa-fighter-jet" />
                    </>
                  )}
                </button>
              </div>
            )}
          </div>

          {isLoading && (
            <div className="text-center p-4">
              <Loader />
            </div>
          )}

          {!isLoading && !isNotFound && (
            <>
              <OrderProgressStepper status={order?.status} orderType = {order?.type} carrier={order?.carrier || order?.platform} />
              <OrderDetailCard
                order={order}
                setOrder={setOrder}
                openCases={openCases}
                openEscalations={openEscalations}
                setOpenEscalations={setOpenEscalations}
                customer={customer}
                assessment={assessment}
                idCheckSummary={idCheckSummary}
                setIdCheckSummary={setIdCheckSummary}
                setCustomer={setCustomer}
                canMarkVerified={canApprove || canDecline || canMarkPending}
                mailLogs={mailLogs}
                canEdit={canEdit}
                canStatusEdit={canStatusEdit}
                canAutomation={canAutomation}
                reminderLoading={reminderLoading}
                reminder={reminder}
                handleReminderChange={handleReminderChange}
                orderStatusChange={orderStatusChange}
                onLocationTransferred={(updatedOrder, note) => {
                  if (updatedOrder) setOrder(updatedOrder);
                  if (note) setNotes((prev) => [note, ...(prev || [])]);
                }}
              />

              <div className="row">

                <div className="col-xl-5 col-lg-5 col-md-5 col-sm-12 col-12">

                  <OrdersHistory groupedOrders = {groupedOrders} />

                  {isPcatdAwaitingReview ? (
                    <PcatdReviewActions
                      order={order}
                      assessment={assessment}
                      setAssessment={setAssessment}
                      productIds={productIds}
                      canApprove={canApprove}
                      canDecline={canDecline}
                      canRefund={canRefund}
                      idCheckSummary={idCheckSummary}
                      onComplete={(updatedOrder) => setOrder(updatedOrder)}
                      setOpenEscalations={setOpenEscalations}
                    />
                  ) : isGslRepeatReview ? (
                    <GslReviewActions
                      order={order}
                      canApprove={canApprove}
                      canDecline={canDecline}
                      onComplete={(updatedOrder) => setOrder(updatedOrder)}
                      setOpenEscalations={setOpenEscalations}
                    />
                  ) : (
                    <ProductAssessments
                      assessment={assessment}
                      order={order}
                      canApprove={canApprove}
                      canDecline={canDecline}
                      canMarkPending={canMarkPending}
                      canRefund={canRefund}
                      canCancel={canCancel}
                      userId={userId}
                      setAssessment={setAssessment}
                      setOrder={setOrder}
                      setOpenEscalations={setOpenEscalations}
                      idCheckSummary={idCheckSummary}
                      setIdCheckSummary={setIdCheckSummary}
                      productIds={productIds}
                    />
                  )}

                  {order &&
                    (order.status === "SEND_TO_RM" ||
                      order.status === "PROCESSED" ||
                      order.status === "PRIME_READY" ||
                      order.status === "ARCHIVE" ||
                      order.status === "TO_CANCEL") && (
                      <div className="d-flex">
                        {canCancel && (
                          <div className="">
                            <div className="mt-4">
                              <Button
                                danger
                                onClick={() => orderCancelRefund("cancel")}
                                disabled={isCancelRefund}
                              >
                                {isCancelRefund && (
                                  <i className="fa fa-spinner fa-spin"></i>
                                )}{" "}
                                Order Cancel
                              </Button>
                            </div>
                          </div>
                        )}
                        {canRefund && order.status !== "PRIME_READY" && (
                          <div className="">
                            <div className="mt-4" style={{ marginLeft: "20px" }}>
                              <Button
                                danger
                                type="dashed"
                                onClick={() => orderCancelRefund("refund")}
                                disabled={isCancelRefund}
                              >
                                {isCancelRefund && (
                                  <i className="fa fa-spinner fa-spin"></i>
                                )}{" "}
                                Cancel & Refund
                              </Button>
                            </div>
                          </div>
                        )}
                      </div>
                  )}

                  <OrderNotes 
                    notes={notes} 
                    orderId={id} 
                    setNotes={setNotes} 
                  />

                </div>

                <div className="col-xl-7 col-lg-7 col-md-7 col-sm-12 col-12">

                  {["Ebay", "Amazon"].includes(order?.platform) && (

                    <div className="mt-3">

                      <ChatHistory
                        canViewMsg = {canViewMsg}
                        canSendMsg = {canSendMsg}
                        messages={messages}
                        isChatLoading={isChatLoading}
                        isNoMessage={isNoMessage}
                        NoMessageText={NoMessageText}
                        textareaRef={textareaRef}
                        message={message}
                        setMessage={setMessage}
                        attachments={attachments}
                        setAttachments={setAttachments}
                        faqs={faqs}
                        setFaqs={setFaqs}
                        handleSendMessage={handleSendMessage}
                        isSending={isSending}
                        order = {order}
                        questions={questions}
                        ticket={ticket}
                        handleCloseTicket={handleCloseTicket}
                        hasUnreadMessage={hasUnreadMessage}
                        setHasUnreadMessage={setHasUnreadMessage}
                        hasMoreMessages={hasMoreMessages}
                        loadOlderMessages={loadOlderMessages}
                        amazonMessagingInfo={amazonMessagingInfo}
                        setOrder={setOrder}
                      />

                    </div>

                  )}

                </div>

              </div>
            </>
          )}
          {!isLoading && isNotFound && (

            <div className="text-center">
              <img
                src="/assets/images/no-data.png"
                style={{ width: "60px", opacity: "0.5" }}
                alt=""
              />
              <h6
                style={{
                  color: "#918f8f",
                  fontFamily: "math",
                  fontWeight: "500",
                }}
              >
                No Data Found
              </h6>
            </div>

          )}
          
        </div>



        <Modal
          open={openCourierModal}
          onCancel={() => setOpenCourierModal(false)}
          footer={null}
          centered
          closeIcon={null}
        >
          <div style={{ textAlign: "center" }}>
            <ExclamationCircleOutlined
              style={{ fontSize: 45, color: "#faad14", marginBottom: 16 }}
            />
            <h4 style={{ fontWeight: 700, marginBottom: 8 }}>
              Confirm Send Order to Courier
            </h4>
            <p style={{ fontSize: 14, marginBottom: 4 }}>
              This will dispatch order <strong>{order?.orderId}</strong> from:
            </p>
            <p style={{ fontSize: 15, color: "#1677ff", fontWeight: 600, marginBottom: 12 }}>
              MI Health Longcroft House
            </p>
            <p style={{ fontSize: 14, color: "#d4380d", fontWeight: 500, marginBottom: 24 }}>
              This action cannot be undone.
            </p>
            <div style={{ display: "flex", justifyContent: "center", gap: 12 }}>
              <button
                onClick={() => setOpenCourierModal(false)}
                className="btn btn-outline-secondary btn-sm"
                disabled={isCourierSending}
              >
                Cancel
              </button>
              <button
                onClick={handleCourierConfirm}
                className="btn btn-sm"
                disabled={isCourierSending}
                style={{ backgroundColor: "#4e7661", borderColor: "#4e7661", color: "#fff" }}
              >
                {isCourierSending ? "Sending..." : "Send Order"}
              </button>
            </div>
          </div>
        </Modal>

        <Modal
          open={openExternalResultModal}
          onCancel={() => setOpenExternalResultModal(false)}
          title="External Courier Dispatch Result"
          centered
          width={860}
          footer={
            <div style={{ textAlign: "right" }}>
              <Button onClick={() => setOpenExternalResultModal(false)}>
                Close
              </Button>
            </div>
          }
        >
          <div style={{ padding: "0 12px" }}>
            <div style={{ marginBottom: 16 }}>
              <div style={{ display: "flex", justifyContent: "space-between", flexWrap: "wrap", gap: 12 }}>
                <div>
                  <div style={{ fontSize: 12, color: "#8c8c8c", textTransform: "uppercase", letterSpacing: "0.05em" }}>
                    Batch ID
                  </div>
                  <div style={{ fontSize: 16, fontWeight: 700 }}>{externalResultData?.batchId || "-"}</div>
                </div>
                <div>
                  <div style={{ fontSize: 12, color: "#8c8c8c", textTransform: "uppercase", letterSpacing: "0.05em" }}>
                    Overall status
                  </div>
                  <div style={{ fontSize: 16, fontWeight: 700, color: externalResultData?.success ? "#389e0d" : "#cf1322" }}>
                    {externalResultData?.success ? "Success" : "Failed"}
                  </div>
                </div>
                <div style={{ flex: 1, minWidth: 240 }}>
                  <div style={{ fontSize: 12, color: "#8c8c8c", textTransform: "uppercase", letterSpacing: "0.05em" }}>
                    Message
                  </div>
                  <div style={{ fontSize: 14, fontWeight: 600, marginTop: 4 }}>
                    {externalResultData?.message || "No summary message available."}
                  </div>
                </div>
              </div>
            </div>

            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16 }}>
              <div style={{ border: "1px solid #f0f0f0", borderRadius: 12, padding: 16, background: "#ffffff" }}>
                <h4 style={{ marginBottom: 12, color: "#2f54eb" }}>Royal Mail</h4>
                <p style={{ marginBottom: 12, color: "#595959" }}>
                  {externalResultData?.royalMail?.message || "No Royal Mail message available."}
                </p>
                {externalResultData?.royalMail?.stats ? (
                  Object.entries(externalResultData.royalMail.stats).map(([label, stats]) => (
                    <div key={label} style={{ marginBottom: 10, padding: 10, borderRadius: 8, background: "#fafafa" }}>
                      <div style={{ fontWeight: 700, marginBottom: 4 }}>{label}</div>
                      <div style={{ display: "flex", justifyContent: "space-between", flexWrap: "wrap", gap: 8 }}>
                        <span>Total: {stats.total}</span>
                        <span>Created: {stats.created}</span>
                        <span>Failed: {stats.failed}</span>
                      </div>
                      {stats.error ? (
                        <div style={{ marginTop: 6, color: "#cf1322" }}>Error: {stats.error}</div>
                      ) : null}
                    </div>
                  ))
                ) : (
                  <div style={{ color: "#8c8c8c" }}>No Royal Mail stats available.</div>
                )}
              </div>

              <div style={{ border: "1px solid #f0f0f0", borderRadius: 12, padding: 16, background: "#ffffff" }}>
                <h4 style={{ marginBottom: 12, color: "#2f54eb" }}>Amazon</h4>
                <p style={{ marginBottom: 12, color: "#595959" }}>
                  {externalResultData?.amazon?.message || "No Amazon message available."}
                </p>
                {externalResultData?.amazon?.stats ? (
                  Object.entries(externalResultData.amazon.stats).map(([label, stats]) => (
                    <div key={label} style={{ marginBottom: 10, padding: 10, borderRadius: 8, background: "#fafafa" }}>
                      <div style={{ fontWeight: 700, marginBottom: 4 }}>{label}</div>
                      <div style={{ display: "flex", justifyContent: "space-between", flexWrap: "wrap", gap: 8 }}>
                        <span>Total: {stats.total}</span>
                        <span>Created: {stats.created}</span>
                        <span>Failed: {stats.failed}</span>
                      </div>
                      {stats.error ? (
                        <div style={{ marginTop: 6, color: "#cf1322" }}>Error: {stats.error}</div>
                      ) : null}
                    </div>
                  ))
                ) : (
                  <div style={{ color: "#8c8c8c" }}>No Amazon stats available.</div>
                )}
              </div>
            </div>
          </div>
        </Modal>

      </Layout>
    </>
  );
};

export default Assessment;
